import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)



let RouteList = [
  {
    path: '/',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
      title: '首页',
      keepAlive: false,
    },
    children: [
      {
        path: '/',
        name: 'Dashboard',
        meta: {
          title: '首页',
          keepAlive: false
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
      },
      {
        path: '/font_awesome',
        name: 'FontAwesome',
        meta: {
          title: 'FontAwesome 图标',
          keepAlive: false
        },
        component: resolve => require(['@/views/icon/FontAwesome.vue'], resolve),
      },
      {
        path: '/element_icon',
        name: 'ElementIcon',
        meta: {
          title: 'Element 图标',
          keepAlive: false
        },
        component: resolve => require(['@/views/icon/ElementIcon.vue'], resolve),
      },
      {
        path: '/post_manage',
        name: 'PostManage',
        meta: {
          title: '预约分配',
          keepAlive: false
        },
        component: resolve => require(['@/views/contentManage/Index.vue'], resolve),
      },
      {
        path: '/post_table',
        name: 'PostTable',
        meta: {
          title: '课程表格',
          keepAlive: false
        },
        component: resolve => require(['@/views/contentManage/classTable.vue'], resolve),
      },
      {
        path: '/post_details',
        name: 'PostDetails',
        meta: {
          title: '预约详情',
          keepAlive: false
        },
        component: resolve => require(['@/views/contentManage/details.vue'], resolve),
      },
      {
        path: '/user_manage',
        name: 'UserManage',
        meta: {
          title: '用户列表',
          keepAlive: true
        },
        component: resolve => require(['@/views/userManage/Index.vue'], resolve),
      },
      {
        path: '/coach_manage',
        name: 'CoachManage',
        meta: {
          title: '教练列表',
          keepAlive: true
        },
        component: resolve => require(['@/views/coachManage/coach_manage.vue'], resolve),
      },
      {
        path: '/user_course',
        name: 'UserCourse',
        meta: {
          title: '添加预约',
          keepAlive: true
        },
        component: resolve => require(['@/views/userManage/addCourse.vue'], resolve),
      },
      {
        path: '/user_add',
        name: 'UserAdd',
        meta: {
          title: '新增用户',
          keepAlive: true
        },
        component: resolve => require(['@/views/userManage/addUser.vue'], resolve),
      },
      {
        path: '/user_payNum',
        name: 'UserPayNum',
        meta: {
          title: '预付费次数',
          keepAlive: true
        },
        component: resolve => require(['@/views/userManage/payNum.vue'], resolve),
      },
      {
        path: '/user_history',
        name: 'UserHistory',
        meta: {
          title: '积分流水',
          keepAlive: true
        },
        component: resolve => require(['@/views/userManage/history.vue'], resolve),
      },
      {
        path: '/user_charts',
        name: 'UserCharts',
        meta: {
          title: '统计图表',
          keepAlive: true
        },
        component: resolve => require(['@/views/userManage/charts.vue'], resolve),
      },
      {
        path: '/user_tables',
        name: 'UserTables',
        meta: {
          title: '个人信息',
          keepAlive: true
        },
        component: resolve => require(['@/views/userManage/tables.vue'], resolve),
      },
      {
        path: '/category_manage',
        name: 'CategoryManage',
        meta: {
          title: '分类列表',
          keepAlive: true
        },
        component: resolve => require(['@/views/categoryManage/Index.vue'], resolve),
      },
      {
        path: '/permission_list',
        name: 'PermissionList',
        meta: {
          title: '权限列表',
          keepAlive: true
        },
        component: resolve => require(['@/views/permissionManage/permission/Index.vue'], resolve),
      },
      //个人中心，可能有修改密码，头像修改等路由
      Personal.index,
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '后台登录',
      keepAlive: false
    },
    components: {
      blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
  },

]


RouteList[0].children.push({
  path: '/build_code',
  name: 'BuildCode',
  meta: {
    title: '构建代码',
    keepAlive: true
  },
  component: resolve => require(['@/views/developmentTool/Build.vue'], resolve),
});

export default new Router({routes: RouteList})


